import type { TextContentWidgetResolved } from './types';
import { WidgetHeading } from './WidgetHeading';

/**
 * The standalone Text Content Widget. Its markup now lives in
 * {@link WidgetHeading}, which other widgets embed so a visibility toggle can
 * take a heading down together with the content it introduces — see the
 * Teachers Widget (SH-344 item 2.13).
 */
export const TextContentWidgetComponent = ({
  resolved,
}: {
  resolved: TextContentWidgetResolved;
}) => <WidgetHeading resolved={resolved} />;
